import { combineReducers } from "redux";
import { client } from "../../client/client";
import { reducer as formReducer } from "redux-form";
import { CleaningReducer } from "./CleaningReducer";
import { selectedCleaningReducer } from "./selectedCleaningReducer";
import { globalReducer } from "./globalReducer";

const rootReducer = combineReducers({
  apollo: client.reducer(),
  form: formReducer,
  cleaning: CleaningReducer,
  selectedCleaning: selectedCleaningReducer,
  global: globalReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js